import React, { useEffect, useState } from 'react';
import getReceiptUrl from '../../services/receiptService';
import './ReceiptButton.scss';

/**
 * A button component that fetches and displays a receipt URL for a Stripe session
 * 
 * @param {Object} props
 * @param {string} props.sessionId - The Stripe checkout session ID
 * @param {string} [props.className] - Additional CSS class name
 * @param {string} [props.buttonText='View Receipt'] - Text to display on button
 */
function ReceiptButton({ sessionId, className = '', buttonText = 'View Receipt' }) {
  const [receiptUrl, setReceiptUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    async function fetchReceiptUrl() {
      if (!sessionId) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const url = await getReceiptUrl(sessionId);
        setReceiptUrl(url);
        
        if (!url) {
          setError('Receipt not available yet');
        }
      } catch (error) {
        console.error('Failed to get receipt:', error);
        setError('Failed to fetch receipt');
      } finally {
        setLoading(false);
      }
    }
    
    fetchReceiptUrl();
  }, [sessionId]);
  
  if (loading) return (
    <button 
      disabled 
      className={`receipt-button loading ${className}`}
    >
      Loading receipt...
    </button>
  );
  
  if (error && !receiptUrl) return (
    <button 
      disabled 
      className={`receipt-button error ${className}`}
      title={error}
    >
      Receipt unavailable
    </button>
  );
  
  if (!receiptUrl) return null;
  
  return (
    <button 
      onClick={() => window.open(receiptUrl, '_blank')}
      className={`receipt-button ${className}`}
    >
      {buttonText}
    </button>
  );
}

export default ReceiptButton; 